export default __webpack_public_path__ + "d3da0838c6fd249c2796eae5b98c08cc.woff";